import { useCallback, useState, useMemo } from 'react';
import { useMutation } from '@ts-core/lib/apollo';
import some from 'lodash/some';
import findIndex from 'lodash/findIndex';

import { useMutationCompletionHandler } from '@ts-core/lib/apollo';

import { useCourseSelector } from 'modules/courses/components/CourseSelector';

import { useStudentsSelector } from '../../components/StudentsSelector';
import { useStudents } from '../../hooks';

import { addStudentsToCourseMutation } from '../../graphql/mutations';

export default function useImportStudentsFromCourse({ courseId, onStudentsImported }) {
  const { onError } = useMutationCompletionHandler();

  const [keepGroups, setKeepGroups] = useState(false);

  const { selectedCourse, props: courseSelectorProps } = useCourseSelector({
    excludedCourses: [courseId],
  });

  const { students: studentsInCourse } = useStudents({ courseId });
  const { students: allAvailableStudents, loading } = useStudents({
    courseId: selectedCourse?._id,
  });
  const students = useMemo(() => {
    return allAvailableStudents.filter((s) => findIndex(studentsInCourse, { _id: s._id }) === -1 && s.personalId);
  }, [allAvailableStudents, studentsInCourse]);

  const showKeepGroupsCheckbox = useMemo(() => {
    return some(students, (s) => s.group);
  }, [students]);

  const onToggleKeepGroups = useCallback(() => {
    setKeepGroups((s) => !s);
  }, []);

  /**
   * Add students
   */
  const [addStudentsToCourse, { loading: submitting }] = useMutation(addStudentsToCourseMutation, {
    onError,
    onCompleted: onStudentsImported,
  });
  const onImportStudents = useCallback(
    (selectedStudents) => {
      const studentsToAdd = selectedStudents.map((s) => {
        const { name, personalId, email, group } = s;
        return {
          name,
          personalId,
          email,
          group: keepGroups ? group?.name : undefined,
        };
      });
      addStudentsToCourse({
        variables: { courseId, input: { students: studentsToAdd } },
      });
    },
    [keepGroups, addStudentsToCourse, courseId]
  );

  const studentsSelectorProps = useStudentsSelector({
    students,
    loading,
    submitting,
    onConfirmSelection: onImportStudents,
  });

  return {
    courseSelectorProps,
    studentsSelectorProps,

    keepGroups,
    showKeepGroupsCheckbox,
    onToggleKeepGroups,
  };
}
